package com.fantasytenis.shared.domain.scoring.entity

/**
 * Live Score domain entity for real-time match updates.
 */
data class LiveScoreEntity(
    val matchId: String,
    val player1: MatchPlayerScore,
    val player2: MatchPlayerScore,
    val currentSet: Int,
    val currentGame: Int,
    val serving: String, // player1 or player2
    val status: LiveMatchStatus,
    val fantasyPoints: Map<String, Double> = emptyMap() // playerId -> points
)

data class MatchPlayerScore(
    val playerId: String,
    val playerName: String,
    val sets: List<Int>,
    val games: Int,
    val points: String, // "0", "15", "30", "40", "AD"
    val tiebreakPoints: Int? = null
)

enum class LiveMatchStatus {
    NOT_STARTED,
    IN_PROGRESS,
    SUSPENDED,
    COMPLETED,
    RETIRED
}

/**
 * Leaderboard entry for contest standings.
 */
data class LeaderboardEntry(
    val userId: String,
    val userName: String,
    val rank: Int,
    val previousRank: Int,
    val points: Double,
    val isCurrentUser: Boolean = false,
    val payout: Double = 0.0,
    // User profile info for leaderboard display
    val username: String? = null,
    val avatarUrl: String? = null,
    // Entry ID for navigation
    val entryId: String? = null
) {
    val rankChange: Int get() = previousRank - rank

    val displayName: String get() = username?.let { "@$it" } ?: userName

    val initials: String get() = when {
        username != null -> username.take(2).uppercase()
        userName.isNotBlank() -> userName.split(" ").mapNotNull { it.firstOrNull()?.uppercaseChar() }.take(2).joinToString("")
        else -> "?"
    }
}

/**
 * Real-time score update event.
 */
data class ScoreUpdateEvent(
    val matchId: String,
    val playerId: String,
    val eventType: String, // ACE, WINNER, DOUBLE_FAULT, etc.
    val pointsAwarded: Double,
    val totalPoints: Double,
    val timestamp: Long
)
